import { EMPTY_ARR } from '../../../../../../constants';
import { Nullable } from '../../../../../../types';
import { ControlledSelectValue } from '../../../types/ControlledSelectOption';

export const getSanitizedControlledSelectValue = <IsMulti extends boolean>(
  value: Nullable<ControlledSelectValue<IsMulti>>,
  isMulti: IsMulti,
): Nullable<ControlledSelectValue<IsMulti>> => {
  if (isMulti) {
    return (Array.isArray(value) ? value : EMPTY_ARR) as Nullable<
      ControlledSelectValue<IsMulti>
    >;
  }

  if (Array.isArray(value)) {
    throw new Error(
      `Expected single value for non-multi select, but got array: ${JSON.stringify(
        value,
      )}`,
    );
  }

  return (value ?? null) as Nullable<ControlledSelectValue<IsMulti>>;
};
